import { Fragment, ReactNode } from "react";
import { cn } from "~/lib/utils";

export interface OverviewTile {
  label: string;
  content: ReactNode;
}

export function OverviewTiles({ tiles, className }: { tiles: OverviewTile[]; className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-x-2 gap-y-1", className)}>
      {tiles.map((tile, i) => (
        <Fragment key={tile.label}>
          {i > 0 && (
            <span className="select-none text-muted-foreground/40" aria-hidden="true">
              ·
            </span>
          )}
          <div className="flex items-center gap-1.5 text-sm">
            <span className="text-muted-foreground">{tile.label}</span>
            <div className="text-foreground/80">{tile.content}</div>
          </div>
        </Fragment>
      ))}
    </div>
  );
}

interface EntityOverviewHeaderProps {
  icon?: ReactNode;
  title: ReactNode;
  tiles: OverviewTile[];
  children: ReactNode;
  className?: string;
}

export function EntityOverviewHeader({
  icon,
  title,
  tiles,
  children,
  className,
}: EntityOverviewHeaderProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      <div className="flex flex-col items-start gap-2">
        {icon}
        {title}
      </div>

      <OverviewTiles tiles={tiles} />

      <div>{children}</div>
    </div>
  );
}
